import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

export const importDemoTerritory = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/importDemo', async (demoTerritoryId, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/demoTools/importDemoTerritory', {
      category: 'rpc',
      type: 'rpc/demoTools/importDemoTerritory',
      params: {
        demoTerritoryId,
        open: true,
      },
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Import Demo Territory Failed',
      error,
    })
  }
})
